import { render, staticRenderFns } from "./medicalOrderList.vue?vue&type=template&id=6953af34&scoped=true&"
import script from "./medicalOrderList.vue?vue&type=script&lang=js&"
export * from "./medicalOrderList.vue?vue&type=script&lang=js&"
import style0 from "./medicalOrderList.vue?vue&type=style&index=0&id=6953af34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6953af34",
  null
  
)

export default component.exports